// Generated by CoffeeScript 2.7.0
var LogicForm;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import LogicFieldListFieldable from 'trunks/vue/admin/components/logic_fields/list/fieldable.js';

export default LogicForm = Vue.extend({
  props: {
    formable: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {
    'logic-fields': LogicFieldListFieldable
  },
  data: function() {
    var ref;
    return {
      saving: false,
      logic_settings: ((ref = this.formable.logic_settings) != null ? ref.constraints : void 0) || {}
    };
  },
  computed: {
    fields: function() {
      return _.chain(this.formable.fields || []).sortBy('position').map(function(field, _index) {
        field.position = _index;
        if (field.type === 'Field::Detail') {
          field.children = _.chain(field.children).sortBy('position').map(function(_field, index) {
            _field.position = index;
            _field.detail = field;
            return _field;
          }).value();
        }
        return field;
      }).value();
    }
  },
  watch: {
    formable: function(value) {
      var ref;
      return this.logic_settings = ((ref = value.logic_settings) != null ? ref.constraints : void 0) || {};
    }
  },
  template: `<div class="formable-edit-view">
  <logic-fields :fields='fields'
                :logic_settings='logic_settings'
                @updateSetting='updateSettingHandle'
                ref='logicFields' />
</div>`,
  created: function() {
    return this.type = this.formable.gid.model_name.demodulize().underscore();
  },
  methods: {
    save: function() {
      if (this.$refs.logicFields.isValid()) {
        if (this.saving) {
          return;
        }
        this.saving = true;
        return Skylark.Libs.Ajax.patch(Skylark.Helpers.UrlHelper.adminUrlFor(this.formable.gid.toPath()), {
          data: {
            [`${this.type}`]: {
              id: this.formable.id,
              logic_settings: {
                constraints: this.logic_settings
              }
            }
          },
          contentType: "application/json; charset=UTF-8",
          success: (data, status, xhr) => {
            newAlertify('保存成功', {
              type: 'success'
            });
            return this.$emit('logicSaved');
          },
          error: function() {
            return newAlertify('保存失败', {
              type: 'error'
            });
          },
          complete: () => {
            return this.saving = false;
          }
        });
      } else {
        newAlertify('保存失败', {
          type: 'error',
          description: '存在逻辑失效的字段'
        });
        return this.displayFirstErrorField();
      }
    },
    updateSettingHandle: function(settings) {
      this.logic_settings = settings;
      return this.$emit('logicSettingChanged', this.logic_settings);
    },
    displayFirstErrorField: function() {
      return this.$refs.logicFields.displayError();
    }
  }
});
